import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule} from '@ngx-translate/core';
import { KycEnterpriseRoutingModule } from './kyc-enterprise-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatInputModule, MatButtonModule, MatSelectModule, MatCardModule,
  MatAutocompleteModule, MatIconModule, MatProgressBarModule, MatFormFieldModule
} from '@angular/material';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { MaterialModule } from 'src/app/core/material';
import { HighchartsChartModule } from 'highcharts-angular';
import {KycEnterpriseComponent} from './kyc-enterprise.component';
import {KycConfirmAccountModule} from './kyc-confirm-account/kyc-confirm-account.module';
import {KycSignModule} from './kyc-sign/kyc-sign.module';
import {KycCameraModule} from './kyc-camera/kyc-camera.module';
import {ConfirmCancelComponent} from './confirm-cancel/confirm-cancel.component';
import {ConfirmFailComponent} from './confirm-fail/confirm-fail.component';
import {ConfirmSuccessComponent} from './confirm-success/confirm-success.component';
import { KycCustomerIdentifyModule } from './kyc-customer-identify/kyc-customer-identify.module';
import { IdentificationMethodModule } from './identification-method/identification-method.module';
import { ConfirmIndentifyComponent } from './confirm-indentify/confirm-indentify.component';
import { KycConfirmAccountModuleReview } from './kyc-confirm-account-review/kyc-confirm-account.module';
import {ConfirmSuccessEnterpriceComponent} from '../../shared/components/confirm-success-enterprice/confirm-success-enterprice.component';

@NgModule({
  declarations: [
    KycEnterpriseComponent,
    ConfirmCancelComponent,
    ConfirmFailComponent,
    ConfirmSuccessComponent,
    ConfirmIndentifyComponent
  ],
  imports: [
    MatFormFieldModule,
    CommonModule,
    KycEnterpriseRoutingModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MaterialModule,
    HighchartsChartModule,
    KycConfirmAccountModule,
    KycCustomerIdentifyModule,
    KycSignModule,
    KycCameraModule,
    IdentificationMethodModule,
    KycConfirmAccountModuleReview
  ],
  entryComponents: [
    ConfirmCancelComponent,
    ConfirmSuccessComponent,
    ConfirmFailComponent,
    ConfirmIndentifyComponent,
    ConfirmSuccessEnterpriceComponent
  ],
  exports: [
    TranslateModule,
  ]
})
export class KycEnterpriseModule { }
